import { render, staticRenderFns } from "./ScustomerNew.vue?vue&type=template&id=0586b9d1&"
import script from "./ScustomerNew.vue?vue&type=script&lang=ts&"
export * from "./ScustomerNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports